import { render, staticRenderFns } from "./rankingTypeDropdown.vue?vue&type=template&id=64acaf25"
import script from "./rankingTypeDropdown.vue?vue&type=script&lang=js"
export * from "./rankingTypeDropdown.vue?vue&type=script&lang=js"
import style0 from "./rankingTypeDropdown.vue?vue&type=style&index=0&id=64acaf25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports